<form [formGroup]="changePasswordForm" class="form">
  <div *ngIf="currentUserRoleType !== 'Admin'" class="row mb-2">
    <div class="col-3 input-label">{{ 'AUTH.INPUT.CURRENT_PASS' | translate }}:</div>
    <div class="col-9">
      <mat-form-field appearance="fill">
        <input
          matInput
          type="password"
          id="oldPassword"
          formControlName="oldPassword"
          autocomplete="off"
          [placeholder]="'AUTH.INPUT.CURRENT_PASS' | translate"
        />
        <mat-error *ngIf="isControlHasError('oldPassword', 'required')"
          >{{ 'AUTH.INPUT.CURRENT_PASS' | translate
          }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
        >
        <mat-error *ngIf="isControlHasError('oldPassword', 'pattern')">{{
          'AUTH.VALIDATION.PATTERN_PASSWORD' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-3 input-label">{{ 'AUTH.INPUT.NEW_PASSWORD' | translate }}:</div>
    <div class="col-9">
      <mat-form-field appearance="fill">
        <input
          matInput
          type="password"
          id="password"
          formControlName="password"
          autocomplete="off"
          [placeholder]="'AUTH.INPUT.NEW_PASSWORD' | translate"
        />
        <mat-error *ngIf="isControlHasError('password', 'required')"
          >{{ 'AUTH.INPUT.NEW_PASSWORD' | translate
          }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
        >
        <mat-error *ngIf="isControlHasError('password', 'pattern')">{{
          'AUTH.VALIDATION.PATTERN_PASSWORD' | translate
        }}</mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row mb-2">
    <div class="col-3 input-label">{{ 'AUTH.INPUT.CONFIRM_PASSWORD' | translate }}:</div>
    <div class="col-9">
      <mat-form-field appearance="fill">
        <input
          matInput
          type="password"
          id="confirmPassword"
          formControlName="confirmPassword"
          autocomplete="off"
          [placeholder]="'AUTH.INPUT.CONFIRM_PASSWORD' | translate"
        />
        <mat-error *ngIf="isControlHasError('confirmPassword', 'required')"
          >{{ 'AUTH.INPUT.CONFIRM_PASSWORD' | translate
          }}{{ 'AUTH.VALIDATION.REQUIRED' | translate }}</mat-error
        >
        <mat-error
          *ngIf="!isControlHasError('confirmPassword', 'required') && f.confirmPassword.invalid"
          >{{ 'AUTH.VALIDATION.NOT_MATCH' | translate }}</mat-error
        >
      </mat-form-field>
    </div>
  </div>
  <div class="d-flex justify-content-end">
    <button
      mat-raised-button
      [disabled]="changePasswordForm.invalid"
      class="btn btn-primary"
      (click)="onSubmit()"
    >
      {{ 'AUTH.INPUT.CHANGE_PASS' | translate }}
    </button>
  </div>
</form>
